import { createFileRoute } from '@tanstack/react-router';

import ComingSoonCover from '@/components/ComingSoonCover';

import placeholder from '../_placeholders/-assets/placeholder-operation-activity.png';

export const Route = createFileRoute(
  '/_staff/licenses/_list/operation-activity/',
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
